export const FILTER_NAME = 'city-mapping'
